module.exports = __webpack_public_path__ + "img/Flag_of_Namibia.ec0b5b0c.svg";